export default "__VITE_ASSET__CM2b52f5__"